import Store from "../commponents/accesorie/Store";
import Footer from "../commponents/Footer";
import Header from "../commponents/Header";

const Accesories = ()=>{
    return (
        <>
            <Header />
            <Store />
            <Footer />
        </>
    )
}

export default Accesories;